export enum Breakpoints {
  sm = 576,
  md = 768,
  lg = 1024,
  xl = 1280,
  "2xl" = 1536,
}

export enum ScreenSize {
  xs = "xs",
  sm = "sm",
  md = "md",
  lg = "lg",
  xl = "xl",
  "2xl" = "2xl",
}
